import Heading from '@atlaskit/heading';
import { Inline, Stack } from '@atlaskit/primitives';
import { createPlacement } from '@post-office/placement-common-v2';
import { type EligibleMessage } from '@post-office/shared-contracts/shared-request-middleware-context';
import { usePlacementApi } from '@post-office/use-placement-api';
import { FormattedMessage } from 'react-intl-next';
import { type MessageTemplateContext } from './test-messages';

export const { createFrontend, createBackend } = createPlacement({
	placementId: 'audio-button-spotlight',
	options: {
		choreographer: {
			isDefaultEnabled: true,
		},
		hideInIsolatedCloud: false,
	},
});

export const PlacementFrontend = createFrontend((Messages) => () => {
	const { data, error, isLoading } = usePlacementApi<{
		messages: Array<EligibleMessage<MessageTemplateContext>>;
	}>('/');

	if (error) {
		throw error;
	}

	return (
		<Stack space="space.150">
			<Heading as={'h1'} size="medium">
				<FormattedMessage
					id="post-office.audio-button-spotlight.main-heading.no-translate"
					defaultMessage="Welcome to Placements v2 hello there"
					description="Example welcome message for Placements v2"
				/>
			</Heading>
			{!isLoading && (
				<Stack as="ul" space="space.200">
					{data.messages.map((props) => (
						<Inline as="li" key={props.messageInstanceId}>
							<Messages.render {...props} />
						</Inline>
					))}
				</Stack>
			)}
		</Stack>
	);
});

export const PlacementBackend = createBackend();
